import Layout from '@modules/layout/components/layout';
import Permissions from '@security/permissions';

const CustomizeSettingsPage = () =>
  import('@modules/subproperty-settings/customize-settings/components/customize-settings-page.vue');

export default [
  {
    path: '',
    component: Layout,
    children: [
      {
        props: true,
        name: 'subpropertyCustomizeSettings',
        path: '/subproperty/settings/customize/:tabName?',
        component: CustomizeSettingsPage,
        exact: true,
        meta: {
          auth: true,
          permission: Permissions.values.settingsEdit,
        },
      },
    ],
  },
];
